const _Conatc=document.getElementById('__formContact');
let overlay = document.getElementsByClassName('loading-overlay')[0]
console.log(_Conatc);
if(_Conatc){

   _Conatc.addEventListener('submit',(e) => {
    e.preventDefault();
    overlay.classList.toggle('is-active')
         const _db= new FormData();
         _db.append('name',_Conatc.name.value);
         _db.append('email',_Conatc.email.value);
         _db.append('messaje',_Conatc.message.value);

         const url='/wp-content/themes/vvhotel/mail/contact-us-from.php';

         fetch(url,{method:'POST',body:_db})
         .then(res=>res.json())
         .then(data=>{
          if(data.success){
            overlay.classList.remove('is-active')
            _Conatc.reset();
            Swal.fire({
              icon: 'success',
              title: '',
              text: 'Thank you for contacting us!',
              allowOutsideClick: false,
              showConfirmButton: false,
              footer: '<a href="https://www.veronicaviewhotel.com/">Go back to start</a>'
            })
          }if(!data.success){
            overlay.classList.remove('is-active')
            _Conatc.reset();
            Swal.fire(
              '',
              'Error cannot be sent!',
              'error'
            )
          }
         })
   })
  }